<svg [attr.width]="width" [attr.height]="height" [attr.fill]="fill">
    <use *ngIf="archivo" [attr.xlink:href]="'assets/svg/catalogo-sprite.svg#' + id"></use>
    <use *ngIf="!archivo" [attr.xlink:href]="'assets/svg/sprite.svg#' + id"></use>
</svg>